export const ContactFieldLabels = {
  name: 'Contact Name:',
  organization: 'Organization:',
  phone: 'Contact Phone:',
  email: 'Contact Email:',
  notes: 'Contact Notes:',
  address: 'Contact Address:',
};
